import { useEffect, useState } from "react";
import { gravatarUrl, initial } from "../lib/user";

// Avatar for the signed-in user: Gravatar (SHA-256) with an initial-letter fallback.
export const UserAvatar = ({ user, size = 28, className = "" }) => {
  const [src, setSrc] = useState(null);
  useEffect(() => {
    let on = true;
    gravatarUrl(user?.email, size * 2).then((u) => on && setSrc(u)).catch(() => {});
    return () => { on = false; };
  }, [user?.email, size]);

  return (
    <span
      data-testid="user-avatar"
      style={{ width: size, height: size }}
      className={`relative flex shrink-0 items-center justify-center overflow-hidden rounded-full bg-ink text-[11px] font-bold text-white ${className}`}
    >
      {initial(user)}
      {src && (
        <img src={src} alt="" className="absolute inset-0 h-full w-full object-cover"
          onError={(e) => e.currentTarget.remove()} />
      )}
    </span>
  );
};
